<div class="border-0 px-4 py-1 scroll-container" ref="ViewTemplate">
  <NavigationBackButton/>
  <div class="row mt-3">
    <!-- Total Templates -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-file-alt fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Total Templates</p>
              <p class="m-0 fw-bold text-white">{{ templates.length }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Assigned Templates -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-file-shield fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Assigned Templates</p>
              <p class="m-0 fw-bold text-white">{{ assigned_templates_count }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending Approvals -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-hourglass-half fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Pending Approvals</p>
              <p class="m-0 fw-bold text-white">0</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recently Updated -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-file-pen fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Recently Updated</p>
              <p class="m-0 fw-bold text-white">{{ recently_updated_count }}</p>
              <p class="mb-0 text-xxs text-white fw-semibold">{{ admins }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card rounded-lg border-0 shadow mt-3">

    <div class="card-header bg-white border-0 rounded-lg mt-2">
      <h6 class="mb-3">Manage Templates</h6>
      <div class="d-flex justify-content-end align-items-center">
        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="redirect_to_upload_template">
          Upload template
        </button>

      </div>
    </div>
    <div class="card-body pt-0">
      <GlobalTable :headers="['ID', 'Template Name', 'Date created', 'Date modified']" :data="table_safe_templates"
        :table_id="'view_template_table'">
        <template #actions="{ row }">
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
           @click="select_template(row)">
            View
          </button>
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal"
            data-bs-target="#assign_trust_template" @click="fetch_entity_types(row.id)">
            Assign Entity Types
          </button>
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark d-none"
            data-bs-toggle="modal" data-bs-target="#update_trust_template" @click="select_template(row)">
            Update
          </button>
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark d-none"
            @click="configure_template(row.id)">
            Configure
          </button>
          <button class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs d-none"
            @click="delete_template_file(row.id)">
            Delete
          </button>
        </template>
      </GlobalTable>
    </div>
  </div>

</div>

<div v-if="preview_modal" @click.self="preview_modal = false">
    <FilePreviewComponent :presigned_url="selected_template.presigned_url" @close="close_the_file_preview" :key="selected_template.presigned_url" />
</div>

<!-- Update template modal -->
 <teleport to="body">
<div class="modal fade" id="update_trust_template" tabindex="-1" aria-labelledby="update_trust_template_label"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3">
      <div class="modal-header border-bottom-0 custom-header text-white">
        <h5 class="modal-title text-xxs" id="update_template_label">
          Update Template
        </h5>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="mb-3">
          <label for="update_template_name" class="form-label text-xxs">Template name</label>
          <input v-model="selected_template.template_name" class="form-control form-control-sm" type="text"
            placeholder="Trust deed template" />
        </div>

        <div class="mb-3">
          <label for="update_template_file" class="form-label text-xxs">Upload new template</label>
          <input class="form-control form-control-sm" id="update_template_file" type="file"
            @change="handle_file_selection" />
        </div>
      </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow-sm" @click="update_template"
          data-bs-dismiss="modal">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Template Modal -->
 <teleport to="body">
<div class="modal fade" id="assign_trust_template" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header custom-header">
        <h5 class="modal-title text-xxs font-weight-bolder text-white opacity-7">
          Assign {{ selected_template.name }} Template
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body py-3">
        <div class="table-responsive">
          <table v-if="table_safe_entity_types.length > 0" class="table table-hover w-100 display nowrap"
            id="trust_types_table">
            <thead class="custom-header">
              <tr>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
                  No
                </th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">
                  Name
                </th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">
                  Description
                </th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">
                  Assign
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in table_safe_entity_types" :key="row.id">
                <td class="text-xxs text-start ps-3">{{ index + 1 }}</td>
                <td class="text-xxs text-start">{{ row.entity_type_name }}</td>
                <td class="text-xxs text-start">{{ row.description }}</td>
                <td class="text-xxs text-start">
                  <div class="form-check form-switch d-flex">
                    <input class="form-check-input" type="checkbox" role="switch" v-model="row.is_assigned"
                      @change="toggle_assignment(row)" :disabled="row.isLoading" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>